import { render, staticRenderFns } from "./NxSigningModalMethodTokenBatch.vue?vue&type=template&id=12bfe898&scoped=true&"
import script from "./NxSigningModalMethodTokenBatch.vue?vue&type=script&lang=js&"
export * from "./NxSigningModalMethodTokenBatch.vue?vue&type=script&lang=js&"
import style0 from "./NxSigningModalMethodTokenBatch.vue?vue&type=style&index=0&id=12bfe898&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12bfe898",
  null
  
)

export default component.exports